module.exports = __webpack_public_path__ + "img/2.d8977ee6.jpg";